import {createGate} from 'effector-react';

export const ViewOrganizationGate = createGate()